import Catering from "../pages/Catering";
import OrderDetails from "../pages/Orders/details";
import MenuForm from "../pages/Menus/menu-form";
import MenuItemForm from "../pages/Menus/menu-item-form";
import MenuItemList from "../pages/Menus/menu-item-list";
import MenuItemDetails from "../pages/Menus/menu-item-details";
import SeatingManagement from "../pages/SeatingManagement";

import Orders from "../pages/Orders";
import Dashboard from "../pages/Dashboard";
import Menus from "../pages/Menus";
import Carts from "../pages/Carts";
import MenuSection from "../pages/MenuSection";
import MenuCustomization from "../pages/MenuCustomization";

// Dashboard
import KPIDashboard from "../pages/Dashboard/KPIDashboard";
import PosDashboard from "../pages/Dashboard/PosDashBoard";
import OrderDashboard from "../pages/Dashboard/OrderDashboard";
import CateringDashboard from "../pages/Dashboard/CateringDashboard";
import DeliveryDashboard from "../pages/Dashboard/DeliveryDashboard";

// Business
import MyBusiness from "../pages/Business/MyBusiness";
import MyRestaurants from "../pages/Business/MyRestaurants";
import Employees from "../pages/Business/Employees/Employee";
import EmployeeTypeList from "../pages/Business/Employees/EmployeeTypeList";
import AddEditEmployee from "../pages/Business/Employees/AddEditEmployee";
import Customers from "../pages/Business/Customers/Customers";
import CustomerDetails from "../pages/Business/Customers/CustomerDetails";
import TableManagement from "../pages/POS/TableManagement";
import Discount from "../pages/Discount";
import AddDiscount from "../pages/Discount/AddDiscount";
import DiscountCodes from "../pages/Discount/DiscountCodes";
import QRcode from "../pages/Business/QRCode/QrCode";
import Payment from "../pages/Business/Payment/Payment";

// Delivery
import ManageOrders from "../pages/Delivery/ManageOrders";
import ManageDrivers from "../pages/Delivery/ManageDrivers";

// Pos
import PosMenu from "../pages/POS/PosMenu/index";
import PosServerLogin from "../pages/POS/PosServerLogin/login";
import EmployeeManagement from "../pages/POS/EmployeeManagement";
import ServerMenu from "../pages/POS/ServerMenu";
import PosTable from "../pages/POS/ServerTable";
import Checkout from "../pages/POS/Checkout";
import OrderPayment from "../pages/POS/Checkout/orderPayment";
import Waitlist from "../pages/POS/WaitList/Waitlist";

// Kds
import Kitchen from "../pages/KDS/Kitchen";
import Expo from "../pages/KDS/Expo";

//setting
import Customizations from "../pages/Settings/Customizations";
import HoursOfOperation from "../pages/Settings/HoursOfOperation";
import Settings from "../pages/Settings";
import PosSetting from "../pages/Settings/PosSetting";
import DeliverySettings from "../pages/Delivery/DeliverySettings";
import MenuSettings from "../pages/Settings/MenuSettings";
import KDSStation from "../pages/Settings/KDSStation";

// Catering
import CateringDetails from "../pages/Catering/CateringDetail";
import CateringMenu from "../pages/Catering/Menu";
import CateringOrder from "../pages/Catering/Orders";
import CateringCalendar from "../pages/Catering/Calendar";

// website
import Theme from "../pages/Website/Theme";
import ThemePreview from "../pages/Website/Theme/ThemePreview";
import Certifications from "../pages/Website/Certifications";
import Testimonials from "../pages/Website/Testimonials";

// assets
import Home_Icon from "../assets/images/home_icon.svg";
import Menu_Icon from "../assets/images/menu_icon.svg";
import Orders_Icon from "../assets/images/orders_icon.svg";
import Delivery_icon from "../assets/images/delivery_icon.svg";
import Kds_icon from "../assets/images/kds_icon.svg";
import Pos_icon from "../assets/images/pos_icon.svg";
import Business_icon from "../assets/images/business_icon.svg";
import CustomerWaitlist from "../pages/CustomerWaitlist";
import WaitingDetails from "../pages/CustomerWaitlist/WaitingDetails";
import Kds from "../pages/KDS";
import { AppstoreAddOutlined, FormatPainterOutlined } from "@ant-design/icons";
import OrderSettings from "../pages/Settings/orderSettings";
import AllEmployee from "../pages/Employee/AllEmployee";
import EmployeType from "../pages/Employee/EmployeType";
import Invite from "../pages/Employee/Invite";
import Deactivated from "../pages/Employee/Deactivated";
import Issues from "../pages/Dashboard/Issues";

//FoodLuv Trail
import PublishWebsite from "../pages/FoodLuvTrail/PublishWebsite";
import Tips from "../pages/Dashboard/TipsDashboard";
import Ratings from "../pages/Dashboard/RatingDashboard";
import Subscription from "../pages/Settings/Subscription";
import Reservation from "../pages/Settings/Reservation";
import CateringSettings from "../pages/Settings/CateringSettings";
import Preview from "../pages/Website/Theme/preview";

//Mobile icon
import Analytics_Mobile from "../assets/images/Analytics_Mobile.svg";
import Orders_Mobile from "../assets/images/Orders_Mobile.svg";
import KDS_Mobile1 from "../assets/images/KDS_Mobile1.svg";
import Menu_Mobile from "../assets/images/Menu_Mobile.svg";
import POS_Mobile from "../assets/images/POS_Mobile.svg";
import Delivery_Mobile from "../assets/images/Delivery_Mobile.svg";
import Business_Mobile from "../assets/images/Business_Mobile.svg";
import Website_Mobile from "../assets/images/Website_Mobile.svg";
import Employee_Mobile from "../assets/images/Employee_Mobile.svg";
import Catering_Mobile from "../assets/images/Catering_Mobile.svg";
import Settings_Mobile from "../assets/images/Settings_Mobile.svg";






const routes = [
  {
    path: "/dashboard",
    label: "Analytics",
    component: Dashboard,
    image: Home_Icon,
    imageMobile: Analytics_Mobile,
    side_menu: true,
    SubMenu: true,
    showInHeader: true,
    subMenus: [
      {
        path: "/kpi",
        label: "KPI Dashboard",
        component: KPIDashboard,
      },
      {
        path: "/pos",
        label: "POS Dashboard",
        component: PosDashboard,
      },
      {
        path: "/delivery",
        label: "Delivery Dashboard",
        component: DeliveryDashboard,
      },
      {
        path: "/order",
        label: "Order Dashboard",
        component: OrderDashboard,
      },
      {
        path: "/catering",
        label: "Catering Dashboard",
        component: CateringDashboard,
      },
      {
        path: "/rating",
        label: "Rating & Reviews",
        component: Ratings,
      },
      {
        path: "/issues",
        label: "Issues",
        component: Issues,
      },
      {
        path: "/tips",
        label: "Tips",
        component: Tips,
      },
    ],
  },
  {
    path: "/orders",
    label: "Orders",
    component: Orders,
    image: Orders_Icon,
    imageMobile: Orders_Mobile,
    side_menu: true,
    SubMenu: true,
    showInHeader: true,
    subMenus: [
      {
        path: "/orders",
        label: "All Orders",
        component: Orders,
      },
      {
        path: "/delivery",
        label: "Delivery",
        component: Orders,
      },
      {
        path: "/takeout",
        label: "Takeout",
        component: Orders,
      },
      {
        path: "/catering",
        label: "Catering",
        component: Orders,
      },
    ],
  },
  {
    path: "/kds",
    label: "KDS",
    component: Kds,
    matchNonExact: true,
    image: Kds_icon,
    imageMobile: KDS_Mobile1,
    side_menu: true,
    SubMenu: true,
    showInHeader: true,
    // subMenus: [
    //   {
    //     path: "/:kdsStation",
    //     label: "Expo Screen",
    //     component: Expo,
    //     icon: <MinusCircleFilled />,
    //   },
    //   {
    //     path: "/kitchen",
    //     label: "Kitchen Screen",
    //     component: Kitchen,
    //     icon: <MinusCircleFilled />,
    //   },
    // ],
  },
  {
    path: "/menu",
    label: "Menu",
    component: Menus,
    image: Menu_Icon,
    imageMobile: Menu_Mobile,
    side_menu: true,
    SubMenu: true,
    showInHeader: true,
    subMenus: [
      {
        path: "/list",
        label: "All Menu",
        component: Menus,
      },
      {
        path: "/add",
        component: MenuForm,
        hideSideMenu: true,
      },
      {
        path: "/section",
        label: "Menu Section and Items",
        component: MenuSection,
        hideSideMenu: true,
      },
      {
        path: "/customization",
        label: "Menu Customizations",
        component: MenuCustomization,
      },
      {
        path: "/settings",
        label: "Menu Settings",
        component: MenuSettings,
      },
    ],
  },
  {
    path: "/pos",
    label: "POS",
    image: Pos_icon,
    imageMobile: POS_Mobile,
    side_menu: true,
    SubMenu: true,
    showInHeader: true,
    component: PosDashboard,
    subMenus: [
      {
        path: "/dashboard",
        label: "POS DashBoard",
        component: PosDashboard,
      },
      {
        path: "/table-management",
        label: "Table Management",
        component: PosDashboard,
        side_menu: false,
        hideSideMenu: true,
      },
      {
        path: "/seating-management",
        label: "Seating Management",
        component: SeatingManagement,
        side_menu: false,
        hideSideMenu: true,
      },
      {
        path: "/server-login",
        label: "Login",
        component: PosServerLogin,
      },
      {
        path: "/server-management",
        label: "Server Management",
        component: EmployeeManagement,
      },
      {
        path: "/waitlist",
        label: "Waitlist",
        component: Waitlist,
      },

      {
        path: "/pos-table",
        component: PosTable,
        side_menu: false,
        hideSideMenu: true,
      },
      {
        path: "/posmenu",
        label: "Menu",
        component: PosMenu,
        hideSideMenu: true,
      },
      {
        path: "/menus/server-menu",
        component: ServerMenu,
        side_menu: false,
        hideSideMenu: true,
      },
      {
        path: "/employee-table",
        component: PosTable,
        side_menu: false,
        hideSideMenu: true,
      },
      {
        path: "/checkout",
        component: Checkout,
        side_menu: false,
        hideSideMenu: true,
      },
      {
        path: "/payment",
        component: OrderPayment,
        side_menu: false,
        hideSideMenu: true,
      },
    ],
  },
  {
    path: "/delivery",
    label: "Delivery",
    component: CateringDashboard,
    image: Delivery_icon,
    imageMobile: Delivery_Mobile,
    side_menu: true,
    SubMenu: true,
    showInHeader: true,
    subMenus: [
      {
        path: "/manage-orders",
        label: "Manage Orders",
        component: ManageOrders,
      },
      {
        path: "/manage-drivers",
        label: "Manage Drivers",
        component: ManageDrivers,
      },
      {
        path: "/order",
        label: "Order Dashboard",
        component: OrderDashboard,
      },
      {
        path: "/kpi-dashboard",
        label: "KPI Dashboard",
        component: KPIDashboard,
      },
      {
        path: "/delivery-settings",
        label: "Delivery Settings",
        component: DeliverySettings,
      },
    ],
  },
  {
    path: "/business",
    label: "Business",
    component: CateringDashboard,
    image: Business_icon,
    imageMobile: Business_Mobile,
    side_menu: true,
    SubMenu: true,
    showin_more: false,
    showInHeader: true,
    subMenus: [
      {
        path: "/my-business",
        label: "Business Profile",
        component: MyBusiness,
      },
      {
        path: "/my-restaurants",
        label: "My Restaurants",
        component: MyRestaurants,
      },
      // {
      //   path: "/employees",
      //   label: "Employees",
      //   component: Employees,
      // },
      {
        path: "/customers",
        label: "Customers",
        component: Customers,
      },
      {
        path: "/customer-details/:id",
        label: "Customer",
        component: CustomerDetails,
        hideSideMenu: true,
      },
      {
        path: "/table-management",
        label: "Table Management",
        component: TableManagement,
      },
      {
        path: "/discounts",
        label: "Discount",
        component: Discount,
      },
      {
        path: "/add-discount",
        component: AddDiscount,
        hideSideMenu: true,
      },
      {
        path: "/edit-discount/:itemId",
        component: AddDiscount,
        hideSideMenu: true,
      },
      {
        path: "/qr-code",
        label: "QR code",
        component: QRcode,
      },
      {
        path: "/payment",
        label: "Payment",
        component: Payment,
      },
      {
        path: "/employees/edit/:id",
        label: "All Employees",
        component: AddEditEmployee,
        hideSideMenu: true,
      },
      {
        path: "/employees/add",
        label: "All Employees",
        component: AddEditEmployee,
        hideSideMenu: true,
      },
      {
        path: "/employee-types",
        label: "Employee Types",
        component: EmployeeTypeList,
        hideSideMenu: true,
      },
    ],
  },
  {
    path: "/foodluv-trial",
    label: "FoodLuv Trial",
    image:Business_icon,
    imageMobile: Business_Mobile,
    component: Settings,
    side_menu: true,
    showin_more: false,
    SubMenu: true,
    showInHeader: true,
    isStepperMenu: true,
    subMenus: [
      {
        path: "/business-profile",
        label: "1. Business Profile",
        component: MyBusiness,
      },
      {
        path: "/restaurant",
        label: "2. Restaurant",
        component: MyRestaurants,
      },
      {
        path: "/menu",
        label: "3. Menu",
        component: MenuForm,
      },
      {
        path: "/website-builder",
        label: "4. Website Builder",
        component: Theme,
      },
      {
        path: "/preview-website",
        label: "5. Preview Website",
        component: ThemePreview,
      },
      {
        path: "/publish-website",
        label: "6. Publish Website",
        component: PublishWebsite,
      },
    
    ],
  },

  {
    path: "/website",
    label: "Website",
    component: Settings,
    imageMobile: Website_Mobile,
    side_menu: true,
    showin_more: true,
    SubMenu: true,
    subMenus: [
      {
        path: "/theme",
        label: "Theme",
        component: Theme,
      },
      {
        path: "/certifications",
        label: "Certifications",
        component: Certifications,
      },
      {
        path: "/testimonials",
        label: "Testimonials",
        component: Testimonials,
      },
    
    ],
  },
 
  {
    path: "/employee",
    label: "Employee",
    component: AllEmployee,
    imageMobile: Employee_Mobile,
    side_menu: true,
    showin_more: true,
    SubMenu: true,
    subMenus: [
      {
        path: "/all",
        label: "All Employee",
        component: AllEmployee,
      },
      {
        path: "/type",
        label: "Employee Type",
        component: EmployeType,
      },
      {
        path: "/invite",
        label: "Invite",
        component: Invite,
      },
      {
        path: "/deactive",
        label: "Deactive",
        component: Deactivated,
      }
    ],
  },
  {
    path: "/catering",
    label: "Catering",
    component: CateringDashboard,
    imageMobile: Catering_Mobile,
    side_menu: true,
    showin_more: true,
    SubMenu: true,
    subMenus: [
      {
        path: "/dashboard",
        label: "Catering Dashboard",
        component: CateringDashboard,
      },
      {
        path: "/calendar",
        label: "Calendar",
        component: CateringCalendar,
      },
      {
        path: "/orders",
        label: "Orders",
        component: CateringOrder,
      },
      {
        path: "/menus",
        label: "Menus",
        component: CateringMenu,
      },
    ],
  },
  {
    path: "/settings",
    label: "Settings",
    component: Theme,
    imageMobile: Settings_Mobile,
    side_menu: true,
    showin_more: true,
    SubMenu: true,
    subMenus: [
      // {
      //   path: "/member",
      //   label: "Member",
      //   component: MemberSetting,
      //   icon: <FormatPainterOutlined />
      // },
      {
        path: "/team-member",
        label: "Theme",
        component: Theme,
      },
      {
        path: "/hours-operation",
        label: "Hours of Operation",
        component: HoursOfOperation,
      },
      {
        path: "/pos-setting",
        label: "POS Setting",
        component: PosSetting,
      },
      {
        path: "/order-settings",
        label: "Order Setting",
        component: OrderSettings,
      },
      {
        path: "/delivery-settings",
        label: "Delivery Settings",
        component: DeliverySettings,
      },
      {
        path: "/menu-setting",
        label: "Menu Settings",
        component: MenuSettings,
      },
      {
        path: "/kds-station",
        label: "KDS Stations",
        component: KDSStation,
      },
      {
        path: "/catering-events",
        label: "Catering",
        component: CateringSettings,
      },
      {
        path: "/reservation-settings",
        label: "Reservation",
        component: Reservation,
      },
      {
        path: "/subscription",
        label: "Subscription",
        component: Subscription,
      }
    ],
  },
    {
    path: "/restaurant/:restaurantCode/waitlist",
    label: "Waitlist",
    component: CustomerWaitlist,
    hideSideMenu: true,
    isPublic: true,
  },
  {
    path: "/restaurant/:restaurantCode/waitlist/:id",
    label: "Waitlist Details",
    component: WaitingDetails,
    hideSideMenu: true,
    isPublic: true,
  },

  {
    path: "/menus/:menuId",
    label: "Menu Items & Sec",
    side_menu: false,
    component: MenuSection,
  },
  {
    path: "/edit-menu/:menuId",
    component: MenuForm,
    side_menu: false,
  },
  {
    path: "/preview",
    component: Preview,
    side_menu: false,
  },
  // {
  // 	path: '/menus/:menuId/menu-items/add',
  // 	component: MenuItemForm,
  // 	side_menu: false
  // },
  // {
  // 	path: '/menus/:menuId/:menuItemId',
  // 	component: MenuItemDetails,
  // 	side_menu: false
  // },
  // {
  // 	path: '/menus/:menuId/menu-items/edit/:menuItemId',
  // 	component: MenuItemForm,
  // 	side_menu: false
  // },
  // {
  // 	path: '/menus/menu-items/:menuName',
  // 	component: MenuItemList,
  // 	side_menu: false
  // },
  {
    path: "/order-details/:orderId",
    component: OrderDetails,
    side_menu: false,
  },
  {
    path: "/discount-codes/:discountId",
    label: "Discounts",
    component: DiscountCodes,
    side_menu: false,
  },
  {
    path: "/catering/:cateringId",
    component: CateringDetails,
    side_menu: false,
  },
  {
    path: "/customizations",
    label: "Customizations",
    component: Customizations,
  },
  {
    path: "/employees",
    label: "Employees",
    component: Employees,
  },
];

export default routes;